import { Component, OnInit, OnDestroy, ViewChild, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../../service/modules/modules.component';
import { ServerService } from '../../../../service/server/server.service';
import { HttpClient, HttpEventType } from '@angular/common/http';


@Component({
  selector: 'app-material-detaile',
  templateUrl: './material-detaile.component.html',
  styleUrls: ['./material-detaile.component.scss']
})
export class MaterialDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1_group: FormGroup | any;
  user_info: any;
  user_id: number | any;
  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  search_array: any = [];
  result: any | undefined;
  temp_inventory: number = 0;
  creator: number | undefined;
  expire: boolean | undefined;
  logo_info: any;
  obj: any;

  logo_site: string | undefined;
  logo: string = this.serverService.get_default_image();
  logo_bin: boolean = false;

  logo2_info: any;
  logo2_site: string | undefined;
  logo2: string = this.serverService.get_default_image();
  logo2_bin: boolean = false;

  list_job_select: any = [];
  cate: number | undefined;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<MaterialDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.cate = dialog_data.cate;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.check_access(5, 1);
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          price: dialog_data.search_array.price,
          status_id: dialog_data.search_array.status_id,
          status_title: dialog_data.search_array.status_title,
          comment: dialog_data.search_array.comment,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.obj = {
      'id': this.id,
      'cate': this.cate
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'price': new FormControl(0),
      'inventory': new FormControl(0, [Validators.pattern('[0-9]{1,}')]),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'weight_title': new FormControl(null),
      'weight': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'place_title': new FormControl(null),
      'place': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'comment': new FormControl(null),
      'pert': new FormControl(null),
      'nasb': new FormControl(null),
      'sod': new FormControl(null),
      'haml': new FormControl(null),
      'haml2': new FormControl(null),
      'convert': new FormControl(null),
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['title'].setValidators([Validators.required])
      this.form1_group.controls['status_id'].setValidators([Validators.required])
    }

  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
            if (type_task == 5) { this.get_status(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      price: this.form1_group.value.price,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      comment: this.form1_group.value.comment,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6041, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].wharehouse_material_title,
            'inventory': res['result'][0].wharehouse_material_inventory,
            'price': res['result'][0].wharehouse_material_price,
            'sort': res['result'][0].wharehouse_material_sort,
            'status_id': res['result'][0].wharehouse_material_status,
            'status_title': res['result'][0].status_title,
            'weight': res['result'][0].wharehouse_weight_id,
            'weight_title': res['result'][0].wharehouse_weight_title,
            'place': res['result'][0].wharehouse_place_id,
            'place_title': res['result'][0].wharehouse_place_title,
            'comment': res['result'][0].wharehouse_material_comment,
            'haml': res['result'][0].wharehouse_material_haml,
            'haml2': res['result'][0].wharehouse_material_haml2,
            'convert': res['result'][0].wharehouse_material_convert,
            'sod': res['result'][0].wharehouse_material_sod,
            'nasb': res['result'][0].wharehouse_material_nasb,
            'pert': res['result'][0].wharehouse_material_pert,
          }
          );
          this.logo_info = {
            site: res['result'][0].wharehouse_material_site,
            path: res['result'][0].wharehouse_material_logo
          }
          if (res['result'][0].wharehouse_material_logo) {
            this.logo = res['result'][0].wharehouse_material_site + "/" + res['result'][0].wharehouse_material_logo;
            this.logo_bin = true;
          }
          else {
            this.logo = this.serverService.get_default_image();
            this.logo_bin = false;
          }

          this.logo2_info = {
            site: res['result'][0].wharehouse_material_site,
            path: res['result'][0].wharehouse_material_logo2
          }
          if (res['result'][0].wharehouse_material_logo2) {
            this.logo2 = res['result'][0].wharehouse_material_site + "/" + res['result'][0].wharehouse_material_logo2;
            this.logo2_bin = true;
          }
          else {
            this.logo2 = this.serverService.get_default_image();
            this.logo2_bin = false;
          }
          this.temp_inventory = res['result'][0].wharehouse_material_inventory;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6037, "user_id": this.user_id
      , 'status_id': this.form1_group.value.status_id
      , 'price': this.form1_group.value.price
      , 'comment': this.form1_group.value.comment
      , 'title': this.form1_group.value.title
      , 'inventory': this.form1_group.value.inventory
      , 'sort': this.form1_group.value.sort
      , 'weight': this.form1_group.value.weight
      , 'place': this.form1_group.value.place
      , 'creator': this.creator
      , 'pert': this.form1_group.value.pert
      , 'nasb': this.form1_group.value.nasb
      , 'sod': this.form1_group.value.sod
      , 'haml': this.form1_group.value.haml
      , 'haml2': this.form1_group.value.haml2
      , 'convert': this.form1_group.value.convert
      , site: this.serverService.get_site()
      , logo_info: this.logo_info
      , logo2_info: this.logo2_info
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = res['result'][0];
          this.insert_order(res['result'][0].wharehouse_material_id);
          //this.serverService.send_cate('material');
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  insert_order(id: number) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6131, id: id, user_id: this.user_id, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: this.result }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  update() {
    if (this.form1_group.value.inventory < this.temp_inventory) {
      this.check_inventory();
    } else {
      this.update2();
    }
  }

  check_inventory() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6004, material: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (Number(res['result'][0].inventory) >= (Number(this.temp_inventory) - Number(this.form1_group.value.inventory))) {
            this.update2();
          }
          else {
            var pe_message = "تعدادی درج شده بیشتر ار خروجی انبار می باشد .لطفا اصلاح نمائید.";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  update2() {
    var obj = {
      'address': 6038, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'price': this.form1_group.value.price
      , 'inventory': this.form1_group.value.inventory
      , 'cate': this.form1_group.value.cate
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'comment': this.form1_group.value.comment
      , 'place': this.form1_group.value.place
      , 'pert': this.form1_group.value.pert
      , 'nasb': this.form1_group.value.nasb
      , 'sod': this.form1_group.value.sod
      , 'haml': this.form1_group.value.haml
      , 'haml2': this.form1_group.value.haml2
      , 'convert': this.form1_group.value.convert
      , 'creator': this.creator
      , 'id': this.id
      , 'weight': this.form1_group.value.weight
      , 'site': this.serverService.get_site()
      , 'logo_info': this.logo_info
      , 'logo2_info': this.logo2_info
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = { result: res['result'][0], i: this.i };
          this.update_order();
          //this.serverService.send_cate('material');
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  update_order() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1984, material_id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(this.result);
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  load_services(id: number) {
    var where = "";
    var code_id;
    if (id == 184) {
    }
    if (id == 220) {
      where += " and wharehouse_material_cate2_cate = " + this.form1_group.value.cate;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, where: where, creator: this.creator, code_id: code_id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 219) {
            this.form1_group.patchValue({
              'place': res.id,
              'place_title': res.title
            })
          }
          if (id == 218) {
            this.form1_group.patchValue({
              'weight': res.id,
              'weight_title': res.title
            })
          }
          if (id == 220) {
            this.form1_group.patchValue({
              'cate2': res.id,
              'cate2_title': res.title
            })
          }
        }
      }
    )

  }


  reset_input(id: number) {
    if (id == 26) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 218) {
      this.form1_group.patchValue({
        'weight': null,
        'weight_title': null
      })
    }
    if (id == 219) {
      this.form1_group.patchValue({
        'place': null,
        'place_title': null
      })
    }
  }
  //********************************************************************* */
  change_logo(event: any) {
    var selectedFile = <File>event.target.files[0];
    var fd = new FormData();
    fd.append("image", selectedFile, selectedFile.name);
    this.serverService.post_address_file(this.server, "uploadImage", fd).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          ///this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
        }
        else if (event.type === HttpEventType.Response) {
          var a = <any>event.body;
          this.logo = this.serverService.get_site() + "/" + this.serverService.get_path_upload_image() + a.result.filename;
          this.logo_bin = true;
          this.logo_info = {
            'site': this.serverService.get_site(),
            'path': this.serverService.get_path_upload_image() + a.result.filename
          }
        }
      }
    )
  }

  delete_logo() {
    this.logo = this.serverService.get_default_image();
    this.logo_bin = false;
    this.logo_info = {
      path: '',
      site: ''
    }
  }
  //********************************************************************* */
  change_logo2(event: any) {
    var selectedFile = <File>event.target.files[0];
    var fd = new FormData();
    fd.append("image", selectedFile, selectedFile.name);
    this.serverService.post_address_file(this.server, "uploadImage", fd).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          ///this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
        }
        else if (event.type === HttpEventType.Response) {
          var a = <any>event.body;
          this.logo2 = this.serverService.get_site() + "/" + this.serverService.get_path_upload_image() + a.result.filename;
          this.logo2_bin = true;
          this.logo2_info = {
            'site': this.serverService.get_site(),
            'path': this.serverService.get_path_upload_image() + a.result.filename
          }
        }
      }
    )
  }

  delete_logo2() {
    this.logo2 = this.serverService.get_default_image();
    this.logo2_bin = false;
    this.logo2_info = {
      path: '',
      site: ''
    }
  }
  //********************************************************************* */
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}